// extracted by mini-css-extract-plugin
export var container = "styles-module--container--j6wyE";
export var content = "styles-module--content--EV+XL";
export var fluid = "styles-module--fluid--R9nQS";
export var nextButton = "styles-module--nextButton--Jeqen";
export var tail = "styles-module--tail--Rkn0Q";
export var tailLeft = "styles-module--tailLeft--EqJVj";
export var tailRight = "styles-module--tailRight--MiVBn";